module.exports = __webpack_public_path__ + "static/media/IDFNord.6fffe199.jpg";